import React from 'react';
import { connect } from 'react-redux';

import SettingsAside from './SettingsAside';
import SettingsMain from './SettingsMain';
import * as fromData from '../../../store/data/reducer';
import { getUser } from '../../../store/auth/reducer';
import { getUpdateErrorMessage, getPasswordErrorMessage } from '../../../store/auth/reducer'
import { updatePassword, updateUser} from '../../../store/auth/actions';
import './settings.css';

const Settings = (props) => {
	const {
		questionsPanel,
		accountPanel,
		passPanel,
		user,
		updateErrorMessage, 
		passwordErrorMessage,
		updatePassword,
		updateUser,
	} = props;

	return (
		<div className="settings">
		<SettingsMain 
			user={user}
			accountPanel={accountPanel}
			passPanel={passPanel}
			updateErrorMessage={updateErrorMessage}
			passwordErrorMessage={passwordErrorMessage}
			updatePassword={values => updatePassword(values)}
			updateUser={values => updateUser(values)}
		/>

		{ questionsPanel && <SettingsAside content={questionsPanel}/> }
		</div>
	);
};

const mapStateToProps = state => {
	return {
		questionsPanel: fromData.getMessageById(state.data, "home_2"),
		accountPanel: fromData.getMessageById(state.data, "settings_account"),
		passPanel: fromData.getMessageById(state.data, "settings_pass"),
		user: getUser(state.auth),
		updateErrorMessage: getUpdateErrorMessage(state.auth),
		passwordErrorMessage: getPasswordErrorMessage(state.auth),
	}
}

export default connect(mapStateToProps, { updatePassword, updateUser })(Settings);


// WEBPACK FOOTER //
// ./src/components/routes/Settings/index.js